import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  data: {
    netSales: 0,
    returns: 0,
    preSales: 0,
    chart: [], // items should have next interface: { date: "YYYY-MM-DD", month: 'MMM', value: <Number> }
    chartStartDate: null,
    chartEndDate: null,
    // TODO: properties below aren't provided by BE yet, so hardcode values defined to testing purpose
    plan: { actual: 0, target: 0 },
    goal: { actual: 0, target: 0 },
    lastYearNetSales: 0,
  },
};

const updateManagerSalesData = (state, payload) => {
  let chartStartDate = null;
  let chartEndDate = null;

  if (Array.isArray(payload.chart) && payload.chart.length > 0) {
    chartStartDate = payload.chart[0]?.date;
    chartEndDate = payload.chart[payload.chart.length - 1]?.date;
  }

  return {
    ...state,
    ...payload,
    chartStartDate,
    chartEndDate,
    lastYearNetSales: payload?.LYNetSales,
  };
};

const managerSalesReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.MANAGER_SALES_DETAILS_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actionTypes.MANAGER_SALES_DETAILS_ERROR:
      return {
        ...INITIAL_STATE,
        error: true,
      };
    case actionTypes.MANAGER_SALES_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: updateManagerSalesData(state.data, payload),
      };
    default:
      return state;
  }
};

export default managerSalesReducer;
